import axios from "axios";
const Papa = require("papaparse");
const fs = require("fs");
import i18n from "../../i18n";
import * as fb from "@/firebase/index.js";
import { floor } from "@tensorflow/tfjs-core";
// import { time } from "console";
export default {
  state: {
    hearingInfo: [],
    lastFetched: null,
    intervalTimer: 300000,
    // hearingLocation: {
    //   "Courtroom 1": "Courtroom 1",
    //   "Courtroom 2": "Courtroom 2",
    //   "Courtroom 3": "Courtroom 3",
    //   "Courtroom 4": "Courtroom 4",
    //   "Courtroom 5": "Courtroom 5",
    //   "Courtroom 6": "Courtroom 6",
    //   "Courtroom 7": "Courtroom 7",
    //   "Courtroom 8": "Courtroom 8",
    //   "Courtroom 10": "Courtroom 10",
    //   "Courtroom 11": "Courtroom 11",
    //   "Courtroom 12": "Courtroom 12",
    //   "Courtroom 14": "Courtroom 14",
    //   "Courtroom 15": "Courtroom 15",
    //   "Courtroom 16": "Courtroom 16",
    //   "Courtroom 17": "Courtroom 17",
    //   "Courtroom 18": "Courtroom 18",
    //   "Courtroom 19": "Courtroom 19",
    // },
    judgeCourtRoomDetails: {
      wheatcraft: "Courtroom 1",
      ryan: "Courtroom 3",
      binder: "Courtroom 4",
      hall: "Courtroom 5",
      black: "Courtroom 6",
      royer: "Courtroom 7",
      maddox: "Courtroom 8",
      carmody: "Courtroom 10",
      forzato: "Courtroom 11",
      mccabe: "Courtroom 12",
      sondergaard: "Courtroom 14",
      verwey: "Courtroom 2",
      rovito: "Courtroom 16",
      sommer: "Courtroom 15",
      platt: "Courtroom 15",
      cody: "Courtroom 15",
      bortner: "Courtroom 15",
    },
  },
  getters: {
    hearingInfo: (state) => state.hearingInfo,
    lastFetched: (state) => state.lastFetched,
    // getHearingLocation: (state) => state.hearingLocation,
    intervalTimer: (state) => state.intervalTimer,
  },
  mutations: {
    setHearingInfo(state, hearingObj) {
      console.log(hearingObj, "hearingObj");
      console.log(hearingObj.length, "Total hearings in hearingObj");
      state.hearingInfo = hearingObj;
    },
    emptyHearingInfo(state) {
      state.hearingInfo = [];
    },
    setLastFetched(state, fetchObj) {
      state.lastFetched = fetchObj;
    },
    setIntervalTimer(state, timer) {
      state.intervalTimer = timer;
    },
  },
  actions: {
    courtroomLocations() {
      return new Promise((resolve, reject) => {
        try {
          // console.log("Maps: ", i18n.t("maps"));
          const result = i18n
            .t("maps")
            .filter((map) => map.showOnHomepage === true)
            .map((mapper) => {
              const floor = i18n
                .t("floors")
                .filter((floor) => floor.floorNumber === mapper.mapFloor);
              return {
                ...mapper,
                floorName: floor.length > 0 ? floor[0].floorName : "",
              };
            });
          // console.log(result,"These are results.")
          resolve(result); // Resolve the promise with the result
        } catch (error) {
          reject(error); // Reject the promise if there's an error
        }
      });
    },
    findMap({ getters }, mapLocation) {
      return new Promise((resolve, reject) => {
        let tempDefaultLocationMap = getters.getMaps.get(
          mapLocation.toLowerCase(),
        );
        let defaultLocationMap = i18n
          .t("maps")
          .filter(
            (map) =>
              map.displayPosition === tempDefaultLocationMap.displayPosition,
          );

        let defaultLocationFloor = i18n
          .t("floors")
          .filter(
            (floor) => floor.floorNumber === defaultLocationMap[0].mapFloor,
          );
        resolve({ map: defaultLocationMap, floor: defaultLocationFloor });
      });
    },

    findJudgeName({ state }, { judgeWithCourtroomsMaps, judgeLastName }) {
      return new Promise((resolve) => {
        console.log(
          judgeWithCourtroomsMaps,
          judgeLastName,
          "Entries in findJudgeName",
        );

        // Function to normalize names (convert to lowercase, remove punctuation, split into words)
        const normalize = (str) =>
          str
            .toLowerCase()
            .replace(/[^a-z\s]/g, "")
            .split(/\s+/);

        // Validate inputs
        if (!judgeWithCourtroomsMaps || !judgeLastName) {
          console.warn(
            "Missing data for finding judge name.",
            judgeLastName,
            judgeWithCourtroomsMaps,
          );
          return resolve("");
        }

        // Normalize the search query
        const searchWords = normalize(judgeLastName);

        // Find a judge whose name contains all words from search query
        const judge = judgeWithCourtroomsMaps.find((map) => {
          if (!map.assignedJudge) return false;

          const assignedWords = normalize(map.assignedJudge);
          return searchWords.every((word) => assignedWords.includes(word));
        });

        if (!judge) {
          console.log(
            judgeWithCourtroomsMaps,
            judgeLastName,
            "These are non matched judges.",
          );
        }

        // Return the matched judge object or the search query if no match is found
        resolve(judge || judgeLastName);
      });
    },

    verifyFile({ dispatch, getters, commit }, targetDateIn) {
      console.log("verifyFile called");
      return (async () => {
        let manualId = 0;
        const data_file = JSON.stringify({
          userName: "chester-pa",
          apiKey:
            "ars-bb-E4uOcpcLgEIKXd-pY5x9Z-bo!7Wl-mLuQCRTmvhqzi4kYpizFdV!tdJizI?Yb75HVSlpw74t-IodAkfSW3qNk7e2OZ8Vwa-ffojXZ2oWrP-AmV0y1z3?SJKmL",
        });

        const config_files = {
          method: "post",
          url: "https://us-central1-chester-pa-70c3b.cloudfunctions.net/apiV2/getHearingFiles/a763cd056f1b2405788443b7197e0708",
          headers: {
            "Content-Type": "application/json",
          },
          data: data_file,
        };

        const mapPath = i18n
          .t("maps")
          .filter((map) => map.hearingLocationCode !== null);

        let judgeWithCourtroomsMaps;
        try {
          judgeWithCourtroomsMaps = await dispatch("courtroomLocations");
        } catch (e) {
          console.error("courtroomLocations failed:", e);
          return false;
        }

        const floorLookup = i18n.t("floors").reduce((lookup, floorRow) => {
          lookup[floorRow.floorNumber] = floorRow.floorName;
          return lookup;
        }, {});

        const floorNumber = mapPath.reduce((acc, map) => {
          if (map.mapFloor in floorLookup) {
            acc[map.mapName] = floorLookup[map.mapFloor];
          }
          return acc;
        }, {});

        let listResponse;
        try {
          listResponse = await axios(config_files);
        } catch (error) {
          console.error("Error fetching files:", error.message);
          return false;
        }

        const temp = [];
        const data = listResponse.data;

        const getFormattedDate = (date, fullYear = false) => {
          const month = date.getMonth() + 1;
          const day = date.getDate();
          const year = fullYear
            ? date.getFullYear()
            : date.getFullYear().toString().slice(-2);
          return `${month}.${day}.${year}`;
        };

        const today = new Date();
        const todayFormattedShort = getFormattedDate(today);
        const todayFormattedLong = getFormattedDate(today, true);
        console.log(
          todayFormattedShort,
          todayFormattedLong,
          "This are the dates",
        );

        const filesOnTargetDate = (data.fileDetails || []).filter((file) => {
          const nameDateMatch = file.name.match(/\d{1,2}\.\d{1,2}\.\d{2,4}/);
          const fileNameDate = nameDateMatch ? nameDateMatch[0] : null;

          if (!fileNameDate) return false;

          const normalizedFileDate = fileNameDate
            .split(".")
            .map((part, index) => (index < 2 ? parseInt(part, 10) : part))
            .join(".");

          return (
            normalizedFileDate === todayFormattedShort ||
            normalizedFileDate === todayFormattedLong
          );
        });

        console.log(filesOnTargetDate, "Files on target Date");

        const normalizeMapDetails = (mapDetails) => {
          if (mapDetails && typeof mapDetails === "object") {
            return mapDetails;
          }
          return {
            mapName: undefined,
            assignedJudge: undefined,
            floorName: undefined,
          };
        };

        const addHearingIfNew = (hearingObj) => {
          if (hearingObj.caseNumber === "" && hearingObj.partyName === "") {
            return;
          }
          const exists = temp.some(
            (item) =>
              item.caseNumber === hearingObj.caseNumber &&
              item.partyName === hearingObj.partyName,
          );
          if (!exists) {
            temp.push(hearingObj);
          }
        };

        const processCpcmsRows = async (rows) => {
          await Promise.all(
            rows.map(async (element) => {
              const col25 = element[25];
              if (col25 == null || String(col25).trim() === "") return;

              const parts = String(col25).trim().split(/\s+/).filter(Boolean);
              const lastPart = parts.pop();
              if (!lastPart) return;

              const mapDetailsRaw = await dispatch("findJudgeName", {
                judgeWithCourtroomsMaps,
                judgeLastName: lastPart,
              });
              if (!mapDetailsRaw) {
                console.log(
                  lastPart,
                  "This are the names not getting map details.",
                );
              }
              const map = normalizeMapDetails(mapDetailsRaw);

              const hearingObj = {
                id: manualId++,
                hearingLocation: map.mapName || element[29],
                isAJudge: /judge/i.test(col25),
                judgeName: /judge/i.test(col25)
                  ? map.assignedJudge ||
                    (String(col25).match(/judge\s+([A-Za-z.\s]+)/i) || [])[1] ||
                    col25
                  : String(col25).replace(/Hearing Officer\s+/i, "").trim(),
                caseNumber: element[30],
                hearingTime: element[24],
                floorName: map.floorName,
                partyName: String(element[31] || "").substring(8),
              };
              addHearingIfNew(hearingObj);
            }),
          );
        };

        const processCvCaRows = async (rows) => {
          await Promise.all(
            rows.map(async (element) => {
              console.log(element, "inside ca/cv");
              const col25 = element[25];
              if (col25 == null || String(col25).trim() === "") return;

              const parts = String(col25).trim().split(/\s+/).filter(Boolean);
              const lastPart = parts.pop();
              if (!lastPart) return;

              const mapDetailsRaw = await dispatch("findJudgeName", {
                judgeWithCourtroomsMaps,
                judgeLastName: lastPart,
              });
              if (!mapDetailsRaw) {
                console.log(
                  lastPart,
                  "This are the names not getting map details.",
                );
              }
              const map = normalizeMapDetails(mapDetailsRaw);

              const hearingObj = {
                id: manualId++,
                hearingLocation: map.mapName || element[29],
                isAJudge: /judge/i.test(col25),
                judgeName: /judge/i.test(col25)
                  ? map.assignedJudge ||
                    (String(col25).match(/judge\s+([A-Za-z.\s]+)/i) || [])[1] ||
                    col25
                  : String(col25).replace(/Hearing Officer\s+/i, "").trim(),
                caseNumber: element[30],
                hearingTime: element[24],
                floorName: map.floorName,
                partyName: element[31],
              };
              addHearingIfNew(hearingObj);
            }),
          );
        };

        void floorNumber;

        if (!filesOnTargetDate.length) {
          console.log("No files to upload today.");
          return true;
        }

        for (const file of filesOnTargetDate) {
          console.log(file, "This is the file for todays hearing");
          const filePayload = JSON.stringify({
            userName: "chester-pa",
            filePath: file.name,
            apiKey:
              "ars-bb-E4uOcpcLgEIKXd-pY5x9Z-bo!7Wl-mLuQCRTmvhqzi4kYpizFdV!tdJizI?Yb75HVSlpw74t-IodAkfSW3qNk7e2OZ8Vwa-ffojXZ2oWrP-AmV0y1z3?SJKmL",
          });

          const detailConfig = {
            method: "post",
            url: "https://us-central1-chester-pa-70c3b.cloudfunctions.net/apiV2/getHearingDetails/a763cd056f1b2405788443b7197e0708",
            headers: {
              "Content-Type": "application/json",
            },
            data: filePayload,
          };

          try {
            const response = await axios(detailConfig);
            const parsedData = Papa.parse(response.data, {
              header: false,
              skipEmptyLines: true,
            });
            const rows = parsedData.data;
            const filePrefix = file.name.split(" ")[0].toLowerCase();

            if (filePrefix === "cpcms") {
              await processCpcmsRows(rows);
            } else if (filePrefix === "cv" || filePrefix === "ca") {
              await processCvCaRows(rows);
            } else {
              try {
                await axios.request({
                  method: "post",
                  maxBodyLength: Infinity,
                  url: "https://cms.chester.arsconnect.com/badftpfiles",
                  headers: {},
                  data: { filename: file.name },
                });
                console.log("BAD FTP File Added");
              } catch (err) {
                console.log(err);
              }
            }
          } catch (error) {
            const status = error.response && error.response.status;
            if (status === 404) {
              console.log("File not present on FTP server");
            } else if (status === 403) {
              console.log("Access problem to FTP Server");
            } else {
              console.error("getHearingDetails failed:", error.message || error);
            }
            return false;
          }
        }

        console.log(temp, "temp");
        commit("setHearingInfo", [...temp]);

        const formatted = temp
          .filter((item) => item)
          .map((item) => {
            const rawTime =
              item.hearingTime == null
                ? ""
                : String(item.hearingTime)
                    .replace("Calendar Event Time:", "")
                    .trim();

            let formattedTime = rawTime;
            const match = rawTime.match(
              /(\d{1,2}:\d{2})(?::\d{2})?\s*(AM|PM)/i,
            );

            if (match) {
              formattedTime = `${match[1]} ${match[2].toUpperCase()}`;
            }

            return {
              caseid: item.caseNumber || "",
              parties: item.partyName ? item.partyName.trim() : "",
              judge: item.judgeName || "",
              location: item.hearingLocation || "",
              start_time: formattedTime,
              hearing_date: new Date().toISOString().split("T")[0],
            };
          });

        console.log("formatted.length", formatted.length);
        console.log("hearingObj-1", formatted);

        if (formatted.length > 0) {
          const importPayload = JSON.stringify({
            applicationId: "ARS-C-00066",
            hearingList: formatted,
          });

          const importConfig = {
            method: "post",
            maxBodyLength: Infinity,
            url: "https://ars-master-dashboard-backend-ie5nk.ondigitalocean.app/api/qr-hearings/import",
            headers: {
              "x-api-key":
                "ars_x7V8xk2JrQmN9Yp4CwL6fTz1UeB3sHjKpA0dMnR5qY8",
              "Content-Type": "application/json",
            },
            data: importPayload,
          };

          void importConfig;
          axios
            .request(importConfig)
            .then((response) => {
              console.log("Hearing details added to Strapi", response);
            })
            .catch((error) => {
              console.log(error);
            });
        }

        const kioskId = getters.getKioskId;
        if (kioskId) {
          try {
            const doc = await fb.kioskCollection.doc(kioskId).get();
            if (doc.exists) {
              const modules = doc.data().modules;
              if (modules.includes("todayshearing")) {
                await fb.kioskCollection.doc(doc.id).update({
                  pullFiles: false,
                });
              }
            }
          } catch (e) {
            console.error("pullFiles kiosk update failed:", e);
          }
        }

        return true;
      })();
    },

    listenToPullFilesChange({ dispatch }) {
      console.trace("Called inside listenToPullFilesChange");
      // fb.kioskCollection.onSnapshot((snapshot) => {
      // snapshot.docChanges().forEach((change) => {
      // if (change.type === "modified") {
      // if (change.doc.data().pullFiles === true) {
      const today = new Date();
      // Take Friday if Sunday else one day before the day.
      today.setDate(today.getDate() - (today.getDay() === 1 ? 3 : 1));
      const datePullFiles = today.toISOString().split("T")[0];

      dispatch("verifyFile", datePullFiles).then((response) => {
        console.log("callback fired");
        if (response) {
          this.loading = false;
        } else {
          this.$store.dispatch(
            "avatarSpeak",
            "Error fetching hearing data. Please go to the Court Administration Office on 4th floor. ",
          );
        }
      });
      // }
      // }
      // });
      // });
    },

    filePullScheduler({ dispatch, getters }) {
      
    },
  },
};
